import { LinearProgress as MuiLinearProgress } from "@mui/material";

export type LinearProgressProps = {
  variant?: "determinate" | "indeterminate" | "buffer" | "query";
  value?: number;
};

export function LinearProgress(props: LinearProgressProps) {
  return <MuiLinearProgress {...props} />;
}
